/**
 * Rundet einen Geldbetrag auf Cent wie `Math.round`: halbe Cent Richtung +∞, auch bei negativen Beträgen
 * (−0,125 → −0,12). Gemeinsam für Server und Client, damit Vorschau und Buchung gleich rechnen.
 * Keine lokalen Kopien anlegen: `tests/server/moneyLocalCopies.test.ts` schlägt fehl.
 *
 * Bewusst abweichende Rundungen bleiben, wo sie sind, weil ein Wechsel Beträge an Grenzwerten
 * (z. B. 1,005) ändern würde: `toFixed(2)` in `distributeEvenly`/`createPaymentPreview`/
 * `coreCustomScheduledPayments`/`CorrectBookingWizard`, `EPSILON` in `cancelSettlementPlan`,
 * BigNumber HALF_UP in `yearEndExport.money`.
 */
export const roundToCents = (value: number): number => Math.round(value * 100) / 100;
